import type { Category } from "@/services/api/categories";

/**
 * Returns the user-facing label for a category.
 * Uses displayName if available, otherwise falls back to name.
 */
export function getCategoryLabel(
  category: { displayName?: string | null; name: string } | null | undefined
): string {
  if (!category) return "";
  return category.displayName || category.name;
}

export function generateCategorySlug(name: string): string {
  return name
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}

export function findCategoryBySlug(
  categories: Category[] | undefined,
  categoryName: string | undefined
): Category | null {
  if (!categories || !categoryName) return null;

  return (
    categories.find((cat) => generateCategorySlug(cat.name) === categoryName) ||
    null
  );
}
